// AccountCreatedModal.jsx
import React from "react";
import ReactModal from "react-modal";

const AccountCreatedModal = ({ isOpen, onClose, accountInfo }) => {
  if (!accountInfo) return null;

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="modal-overlay"
      className="modal-wrap"
    >
      <div className="modal-container" style={{ maxWidth: "500px", minWidth: "400px" }}>
        <div className="modal-header">
          <h5>계정 생성 완료</h5>
          <button type="button" className="modal-btn-close" onClick={onClose}>
            <span className="modal-btn-span">X</span>
          </button>
        </div>
        <div className="modal-content" style={{ padding: "24px" }}>
          <p style={{ marginBottom: "16px", fontWeight: "bold" }}>
            R2(업체 관리자) 계정이 자동 생성되었습니다.
          </p>
          <table className="table-write" style={{ width: "100%" }}>
            <tbody>
              <tr>
                <th style={{ width: "40%" }}>계정 ID</th>
                <td>
                  <span style={{ color: "#007bff", fontWeight: "bold" }}>
                    {accountInfo.id}
                  </span>
                </td>
              </tr>
              <tr>
                <th>초기 비밀번호</th>
                <td>
                  <span style={{ color: "#007bff", fontWeight: "bold" }}>
                    {accountInfo.rawPassword}
                  </span>
                </td>
              </tr>
              <tr>
                <th>권한</th>
                <td>R2 (업체 관리자)</td>
              </tr>
            </tbody>
          </table>
          <p style={{ marginTop: "16px", fontSize: "13px", color: "#dc3545" }}>
            ※ 최초 로그인 시 반드시 비밀번호를 변경해야 합니다.
          </p>
        </div>
        <div className="modal-btn-wrap btn-right-box">
          <ul>
            <li>
              <button type="button" className="btn-save" onClick={onClose}>
                확인
              </button>
            </li>
          </ul>
        </div>
      </div>
    </ReactModal>
  );
};

export { AccountCreatedModal };
